/**
 * Document Data Transformer
 * Transforms nested document API response to flat structure for DocumentDetailsSlider
 */

/**
 * Transforms document data from API response format to DocumentDetailsSlider format
 * @param documentData - Raw document data from API
 * @returns Transformed data suitable for DocumentDetailsSlider
 */
export const transformDocumentDataForSlider = (documentData: any) =>
{
	if (!documentData || !documentData.files || documentData.files.length === 0)
	{
		console.warn('Invalid document data provided to transformer');
		return null;
	}

	const file = documentData.files[0]; // Get first file from files array

	// Transform the nested structure to flat structure expected by DocumentDetailsSlider
	const transformedData = {
		// Basic details from file object
		id          : documentData._id,
		title       : file.title,
		description : file.description,
		url         : file.url,
		fileType    : file.fileType,
		fileSize    : file.fileSize,
		pageCount   : file.pageCount,

		// Thumbnail handling
		thumbnail : file.thumbnail,

		// Metadata
		metadata : file.metadata,

		// Access control and permissions from file level
		visibility    : file.visibility?.toLowerCase(),
		allowDownload : file.allowDownload,
		allowShare    : file.allowShare,
		accessControl : file.accessControl,

		// Categories and tags - use file level first, fallback to collection level
		categoryIds : file.categoryIds || documentData.categoryIds,
		tags        : file.tags || documentData.tags,

		// Status and publishing
		status      : file.status?.toLowerCase(),
		publishDate : file.publishDate || documentData.publishedAt,

		// Additional file properties
		order      : file.order,
		uploadedAt : file.uploadedAt || documentData.documentCreatedAt,

		// Collection level properties
		companyId  : documentData.companyId,
		sourceType : documentData.sourceType?.toLowerCase(),

		// Creator information
		createdBy   : documentData.createdBy,
		updatedBy   : documentData.updatedBy,
		publishedBy : documentData.publishedBy,

		// Engagement data
		engagement : documentData.engagement,

		// Additional metadata
		documentCreatedAt : documentData.documentCreatedAt,
		documentUpdatedAt : documentData.documentUpdatedAt,
		scheduledPublishDate : documentData.scheduledPublishDate,

		// Keep original for reference
		originalData : documentData
	};

	return transformedData;
};
